<template>
  <div>
    <h3 class="main">画面信息</h3>
    <div class="box">
      <div class="fs-16">
        <label class="textend">画面名称：</label>
        <label class="textstart">{{ pageName }}</label>
      </div>
      <div>
        <label class="textend">画面URL：</label>
        <label class="textstart">{{ pageUrl }}</label>
      </div>
      <div>
        <label class="textend">画面类型：</label>
        <label class="textstart">{{ pageKnd }}</label>
      </div>
    </div>
    <h3 class="main">api信息</h3>
    <div class="search-result">
      <div class="search-functions-headers">
        <div class="search-functions">
          <BBtnPrimary
            :img-src="require('@/assets/new.png')"
            :clicked="addApi"
            btn-txt="添加"
          />
        </div>
      </div>
      <Table
        :headers="headers"
        :tableData="apiList"
        :length="totalPages"
        :total-visible="7"
        :page-num="pageNum"
        v-model="pageNum"
        @input="doSearch(false)"
      >
        <template v-slot:actions="item">
          <div style="display:flex;flex-direction:row;justify-content: center;">
            <div class="btn-detail" @click="handleDetail(item.data)">
              编辑
            </div>
            <div class="btn-delete" @click="handleDelete(item.data.id)">
              删除
            </div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
import { apiList, deleteApi } from "@/api/pageManagement";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Table from "../../components2/Table";
import Hub from "../../events/Hub";
import PopupContents from "../../views2/sample/PopupContents";
import Vue from "vue";
export default {
  name: "TeachTeam",
  components: {
    Table,
    BBtnPrimary,
  },
  data() {
    return {
      loading: false,
      totalPages: 0,
      pageNum: 1,
      pageCount: 10,
      totalCount: 0,
      pageId: 0,
      pageName: "",
      pageUrl: "",
      pageKnd: "",
      headers: [
        { text: "编号", value: "indexNum", sortable: false, align: "center" },
        { text: "api-url", value: "apiUrl", sortable: false, align: "center" },
        { text: "api名称", value: "apiName", sortable: false, align: "center" },
        {
          text: "创建时间",
          value: "createTime",
          sortable: false,
          align: "center",
        },
        {
          text: "修改时间",
          value: "updateTime",
          sortable: false,
          align: "center",
        },
        { text: "操作", value: "actions", sortable: false, align: "center" },
      ],
      apiList: [],
      deleteId: 0,
      data: {},
      navi: [{ name: "page-management" }, { name: "page-management-detail" }],
    };
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
  beforeMount() {
    this.$store.commit("SET_NAVI_DATA", this.navi);
  },
  mounted() {
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
  created() {
    // 页面初期化
    // this.comUtils.saveStorage(this.$store);
     if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.pageId = vm.$route.params.pageId;
      vm.pageName = vm.$route.params.pageName;
      vm.pageUrl = vm.$route.params.pageUrl;
      vm.pageKnd = vm.$route.params.pageKnd;

      // 参数赋值 班级id
      if (vm.pageId || vm.pageName || vm.pageUrl || vm.pageKnd) {
        // 把不为空的参数存入缓存
        const params = {
          pageId: vm.pageId,
          pageName: vm.pageName,
          pageUrl: vm.pageUrl,
          pageKnd: vm.pageKnd,
        };
        vm.$store.commit("SET_PAGE_DETAIL_PARAMS", params);
      }

      // 查询条件赋值
      if (vm.$store.state.pageManagementDetail_pageId) {
        vm.pageId = vm.$store.state.pageManagementDetail_pageId;
      }
      if (vm.$store.state.pageManagementDetail_pageName) {
        vm.pageName = vm.$store.state.pageManagementDetail_pageName;
      }
      if (vm.$store.state.pageManagementDetail_pageUrl) {
        vm.pageUrl = vm.$store.state.pageManagementDetail_pageUrl;
      }
      if (vm.$store.state.pageManagementDetail_pageKnd) {
        vm.pageKnd = vm.$store.state.pageManagementDetail_pageKnd;
      }

      // 页面初期化
      vm.doSearch(true);
    });
  },
  methods: {
    // 点击查询
    doSearch(flag) {
      this.loading = true;
      if (flag) {
        this.totalPages = 0;
        this.pageNum = 1;
        this.pageCount = 10;
        this.totalCount = 0;
      } else {
        // 查询条件赋值
        if (this.$store.state.pageManagementDetail_pageId) {
          this.pageId = this.$store.state.pageManagementDetail_pageId;
        }
      }
      this.searchList();
    },
    // 查询page列表
    async searchList() {
      var param = {
        page: this.pageNum,
        limit: this.pageCount,
        id: this.pageId,
      };
      const data = await apiList(param);
      if (data.apiList != null || data.apiList === "") {
        this.apiList = data.apiList;
      }
      this.totalCount = data.totalCount;
      this.totalPages = Math.ceil(this.totalCount / this.pageCount);
      this.loading = false;
    },
    addApi() {
      this.$router.push({
        name: "page-management-detail-add",
        params: {
          pageId: this.pageId,
          apiUrl: null,
          apiName: null,
          editFlg: '0',
        },
      });
    },
    // 点击编辑
    handleDetail(item) {
      this.$router.push({
        name: "page-management-detail-add",
        params: {
          pageId: this.pageId,
          apiUrl: item.apiUrl,
          apiName: item.apiName,
          id: item.id,
          editFlg: '1',
        },
      });
    },
    // 点击删除
    handleDelete(id) {
      this.data.bodyText = "确认是否删除？";
      this.deleteId = id;
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.data.bodyText, "删除", PopupContents);
    },
    set(value) {
      if (value == 1) {
        this.delete();
      }
    },
    async delete() {
      const data = await deleteApi(this.deleteId);
      if (data.code === 1) {
        this.doSearch(false);
        Vue.prototype.$vsnackbar.show(data.message);
      } else {
        Vue.prototype.$valertbar.show(data.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}

.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}

.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-around;
}

.fs-16 {
  font-size: 16px;
}

.main {
  display: inline-block;
  font-weight: bolder;
  margin: 20px 0 0 25px;
}
</style>
